enum ProductInformationSectionSecurityAndComplianceEnum {
	warning = 'Warning',
	safetyInformation = 'Safety Information',
	ageRecommendation = 'Age recommendations',
	testResultsAndCompliance = 'Test results and compliance'
}
export default ProductInformationSectionSecurityAndComplianceEnum;
